import Component from './applicant_table.vue'
export default Component
